import Vue from 'vue'
import Router from 'vue-router'
// 定义路由组件
// import footer from'@/components/footer'
import home from '@/page/home'
import historycard from '@/page/historycard'
import lifehistory from '@/page/lifehistory'
import lifepay from "@/page/lifepay"
import rehistory from "@/page/rehistory"
import customer from "@/page/customer"
import mine from "@/page/mine"
import login from "@/page/login"
import hongbao from "@/page/hongbao"
import wallet from "@/page/wallet"
import proposal from "@/page/proposal"
import phoneset from "@/page/phoneset"

Vue.use(Router)

export default new Router({
  mode: 'history',
  //base:'h5',
  routes: [{
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/historycard',
      name: 'historycard',
      component: historycard
    },
    {
      path: '/lifehistory',
      name: 'lifehistory',
      component: lifehistory
    },
    {
      path: '/rehistory',
      name: 'rehistory',
      component: rehistory
    },
    {
      path: '/lifepay',
      name: 'lifepay',
      component: lifepay
    },
    {
      path: '/customer',
      name: 'customer',
      component: customer
    },
    {
      path: '/mine',
      name: 'mine',
      component: mine,
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/hongbao',
      name: 'hongbao',
      component: hongbao,
    },
    {
      path: '/wallet',
      name: 'wallet',
      component: wallet,
    },
    {
      path: '/proposal',
      name: 'proposal',
      component: proposal,
    },
    {
      path: '/phoneset',
      name: 'phoneset',
      component: phoneset,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js